import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import galleryService, { GALLERY_CORE_FOLDER_SLUGS } from 'services/gallery';

const initialState = {
  loading: false,
  types: [],
  folders: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchGalleryTypes = createAsyncThunk('galleries/types', (params = {}) => {
  return galleryService.getFolders({ ...initialState.params, ...params }).then((res) => res);
});

export const fetchGalleryAll = createAsyncThunk(
  'gallery/fetchAll',
  (params = {}) => {
    return galleryService
      .getAllFolders({
        includeFiles: params.includeFiles ?? false,
        perPage: params.perPage ?? 10,
        ...params,
      })
      .then((res) => res);
  }
);

const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchGalleryTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchGalleryTypes.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.types = payload?.data ?? [];
      state.error = '';
    });
    builder.addCase(fetchGalleryTypes.rejected, (state, action) => {
      state.loading = false;
      state.types = [];
      state.error = action.error?.message ?? '';
    });

    builder.addCase(fetchGalleryAll.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchGalleryAll.fulfilled, (state, action) => {
      const { payload } = action;
      const raw = payload?.data?.folders ?? [];
      const coreSet = new Set(GALLERY_CORE_FOLDER_SLUGS);
      const norm = (f) =>
        String(f?.slug ?? f?.name ?? f?.type ?? '')
          .toLowerCase()
          .replace(/-/g, '_')
          .trim();
      const allowed = raw.filter((f) => coreSet.has(norm(f)));
      state.folders = GALLERY_CORE_FOLDER_SLUGS.map((s) =>
        allowed.find((f) => norm(f) === s)
      ).filter(Boolean);
      state.loading = false;
      state.error = '';
    });
    builder.addCase(fetchGalleryAll.rejected, (state, action) => {
      state.loading = false;
      state.folders = [];
      state.error = action.error?.message ?? '';
    });
  },
});

export default gallerySlice.reducer;
